var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Visible)?_c('span',{staticClass:"timer"},[_c('b-tag',{attrs:{"rounded":"","type":"is-light"}},[_vm._v(" "+_vm._s(_vm.countdown)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }